import { Directive, Inject, Input, Self, TemplateRef } from '@angular/core'

@Directive({
  selector: '[mmxColumnTemplate]',
  standalone: false,
})
export class CellTemplateDirective {
  @Input() template: TemplateRef<any>
  @Input('mmxColumnTemplate') name: string

  constructor(@Self() @Inject(TemplateRef) private _tmp: TemplateRef<any>) {
    this.template = this._tmp
  }
}
